exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".DevTools {\n  position: fixed;\n  z-index: 40;\n  top: 20px;\n  right: 20px;\n  padding: 20px;\n  background: #f7f9fb;\n  border: 1px solid #e2e4e6;\n  border-radius: 2px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); }\n  .DevTools-section {\n    margin-top: 10px;\n    padding-top: 10px;\n    border-top: 1px solid #e2e4e6; }\n", ""]);

// exports
